<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {}
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue